export default function ShowSupportForInstitution() {
  return (
    <div className='text-center text-sm text-gray-600 dark:text-gray-400 py-2 md:py-4 px-16 bg-gray-50 dark:bg-slate-700 shadow-md'>
      Want unlimited access to Writefull X, Writefull for Word, and Writefull for Overleaf?{' '}
      <a
        href={`${import.meta.env.VITE_WF_CUSTOMER_PORTAL_URL}/support-a-writefull-university-subscription`}
        className='underline'
        target='_blank'
        rel='noopener noreferrer'
      >
        Show your support
      </a>{' '}
      for a license at your institution.
    </div>
  )
}
